import { render, staticRenderFns } from "./OnofficeActivationApp.vue?vue&type=template&id=bd9cdba0&"
import script from "./OnofficeActivationApp.vue?vue&type=script&lang=js&"
export * from "./OnofficeActivationApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports